<template>
  <div class="ibox-content">
    <div class="row mt-4">
      <div class="col-md-12">
        <strong>
          {{ infoTotalModels }}
        </strong>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-border table-align">
          <thead>
            <tr>
              <th>Protocolo</th>
              <th>Placa</th>
              <th>Renavam</th>
              <th>Situação</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="history in chronotachographHistories" :key="history.id">
              <td>{{ history.protocol }}</td>
              <td>{{ history.plate }}</td>
              <td>{{ history.renavam }}</td>
              <td>{{ history.situation }}</td>
              <td>{{ history.updatedAt | datetime }}</td>
              <td>
                <button v-if="isSuperUser" class="btn btn-primary" @click="showDetails(history)">
                  Detalhes
                </button>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>

    <Modal v-model="showModal" v-if="currentTicketHistory">
      <pre><small><code>{{ currentTicketHistory }}</code></small></pre>
    </Modal>

  </div>
</template>
<script>

import ModelMapper from '@/mixins/ModelMapper'
import Modal from '../shares/specialTag/Modal.vue'
import GetUser from '@/mixins/GetUser'
import { IssuingAuthority } from '@/models/IssuingAuthority';

export default {
  components: {Modal},
  computed: {
    chronotachographHistories() {
      return this.getModels || []
    },
  },
  created() {
    this.addOrderBy('createdAt')
    this.defaultModelSetting.updateQueryURL = true

    this.asyncTemplateSelect({
      byURL: true,
      pagination: true,
    })
  },
  data: () => ({
    currentTicketHistory: null,
    modelPathPrefix: 'maestro',
    nameModel: 'TicketHistories',
    showModal: false,
    chronotachographId: null,
  }),
  methods: {
    buildPath() {
      return `maestro/chronotachographs/${this.chronotachograph.id}/histories`
    },
    showDetails(chronotachographHistory) {
      this.currentTicketHistory = chronotachographHistory
      this.showModal = true
    },
    translateStatus(value) {
      return {
        expired: 'Vencido',
        opened: 'Em aberto',
        undefined: 'Indefinido',
        paid: 'Pago',
      }[value] || value
    },
    translateAuthority(value) {
      return IssuingAuthority.label(value)
    },
  },
  mixins: [ModelMapper, GetUser],
  name: 'ChronotachographHistories',
  props: {
    chronotachograph: {
      required: true,
      type: Object,
    }
  }
}

</script>

<style scoped>

</style>